import { StyleProp, StyleSheet, View, ViewStyle, Switch } from 'react-native'
import { color, fontFamily } from '../../../theme'
import { useEffect, useState } from 'react'
import { DS } from '../../../design-system'
import { observer } from 'mobx-react-lite'

export type AVControlProps = {
  icon: JSX.Element
  name: string
  statusText: string
  onPress: () => void
  customCircleStyle?: StyleProp<ViewStyle>
  isSwitchEnabled?: boolean | undefined
  isTeacherOpeningOtherPlayer?: boolean | undefined
}

export const AVControl = observer(
  ({
    icon,
    name,
    onPress,
    statusText,
    customCircleStyle,
    isSwitchEnabled,
    isTeacherOpeningOtherPlayer
  }: AVControlProps) => {
    const [isEnabled, setIsEnabled] = useState(false)

    useEffect(() => {
      setIsEnabled(isSwitchEnabled ?? false)
    }, [isSwitchEnabled])

    const toggleSwitch = () => {
      setIsEnabled(!isEnabled)
      onPress()
    }

    return (
      <View style={styles.avContainer}>
        <View style={{ flexDirection: 'row', gap: 16, alignItems: 'center' }}>
          <View style={[styles.circleButton, customCircleStyle]}>{icon}</View>
          <View style={{ flexDirection: 'column' }}>
            <DS.Text variant="Heading 4/Regular">{name}</DS.Text>
            <DS.Text variant="Mini/Bold">{statusText}</DS.Text>
          </View>
        </View>
        <Switch
          trackColor={{ false: '#DDDAD2', true: '#7B043D' }}
          thumbColor={isEnabled ? '' : '#f4f3f4'}
          ios_backgroundColor="#DDDAD2"
          onValueChange={toggleSwitch}
          value={isEnabled}
          disabled={isTeacherOpeningOtherPlayer}
        />
      </View>
    )
  }
)

const styles = StyleSheet.create({
  avContainer: {
    alignItems: 'center',
    gap: 8,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  circleButton: {
    backgroundColor: color.palette.white,
    width: 56,
    height: 56,
    borderRadius: 28,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: color.palette.lightGrey
  },
  name: {
    fontFamily: fontFamily.GTAmericaExtended,
    fontSize: 10,
    color: color.palette.smokyBlack
  },
  status: {
    fontFamily: fontFamily.FeatureDeckExtrabold,
    fontSize: 22,
    color: color.palette.smokyBlack
  }
})
